import * as Immutable from 'immutable';
import { createActions } from 'redux-actions';

export const {
  toggleFunctionsProperty,
  setAlphaPropertiesData,
  setAlphaPropertiesDataErrors,
  setTagsOptions,
  clearAlphaProperties,
  hasUpdatedProperties,
  resetProperties,
  clearScrollToAlphaProperties,
  setAlphaPropertiesError,
  setFieldOnFocus,
} = createActions(
  {
    TOGGLE_FUNCTIONS_PROPERTY: (property: string, value: boolean) => ({ property, value }),
    SET_ALPHA_PROPERTIES_DATA: (data: Immutable.Map<string, any>) => ({ data }),
    SET_ALPHA_PROPERTIES_DATA_ERRORS: (data: Immutable.Map<string, any>) => ({ data }),
    SET_TAGS_OPTIONS: (data: any) => ({ data }),
  },
  'CLEAR_ALPHA_PROPERTIES',
  'HAS_UPDATED_PROPERTIES',
  'RESET_PROPERTIES',
  'CLEAR_SCROLL_TO_ALPHA_PROPERTIES',
  'SET_ALPHA_PROPERTIES_ERROR',
  'SET_FIELD_ON_FOCUS'
);
